module.exports = __webpack_public_path__ + "img/r.3664cfa8.jpg";